export const BLOCK_PROMO_TEST_IDS = {
    MOBILE_CAROUSEL: 'block-promo-mobile-carousel',
};
